<template>
    <div>
        <Hero title="Book"/>

        <div class="grid lg:grid-cols-2 mt-5 p-8 md:p-20">
            <div class="text-xl lg:pe-20 flex flex-col gap-9">
                <div class="font-bold text-xl md:text-4xl"> METAMORPHOSIS: Transforming your life by the Word of God: Can change be guaranteed?</div>

                <div>
                    This book is inspired by a desire to see believers win. We see clearly from God's Word that we are to have a life of victory. Victory over satan, sin, diseases, fear, depression, etc. We are also to set others free, but believers still find that their experiences are not always consistent with God's Word. This book provides a practical answer and guide to walking in the victory that Jesus has provided. Read. Apply. Win!
                </div>

                <div>
                    <div class="font-bold text-lg">Contents</div>
                    <ul>
                        <li class="ms-10">Renewing your mind</li>
                        <li class="ms-10">The "how" of mind renewal</li>
                        <li class="ms-10">Confidence in the word</li>
                        <li class="ms-10">Be strong and very courageous</li>
                        <li class="ms-10">Doing it right</li>
                        <li class="ms-10">Confessions</li>
                    </ul>
                </div>

                <div>
                    You can get the book if you’re in Nigeria (whatsapp +234 814 321 1989) , or outside the country on Amazon.
                </div>

                <div class="grid md:flex gap-2">
                    <a href="https://www.amazon.com/dp/B0CTKYV41N?ref=d6k_applink_bb_dls&dplnkId=335ff625-006e-4801-b1ea-2e25e460fa1b" target="_blank">
                        <div class="w-full md:max-w-fit text-center text-base px-6 py-3 text-white border-2 border-orange-500 bg-orange-500 rounded hover:cursor-pointer">
                            <i class="fa-brands fa-amazon me-2"></i> Get on Amazon
                        </div>
                    </a>

                    <a href="https://wa.me/+2348143211989?text=Hello Ma, I am interested in getting the book Metamorphosis. I stay at ..." target="_blank">
                        <div class="w-full md:max-w-fit text-center text-base px-4 py-3 border-2 border-orange-500 rounded hover:cursor-pointer">
                            <i class="fa-brands fa-whatsapp me-2"></i> Whatsapp +234 814 321 1989
                        </div>
                    </a>                    

                </div>
            </div>
            <div class="lg:pe-5 pt-5">
                <img src="../assets/images/book.jpeg" :alt="`book thumbnail`" class="w-full">
            </div>
        </div>
    </div>
</template>

<script setup>
import Hero from '../components/Devotional/Hero.vue';

</script>

<style scoped>

</style>